import { type Placement } from '@floating-ui/react';
import { type ReactNode } from 'react';

import { toIsoString } from '@/utils/dates';

import { DatetimePicker } from '../DatetimePicker/DatetimePicker';

export interface DatepickerProps {
  autoFocus?: boolean;
  disabled?: boolean;
  error?: string;
  filterDate?: (date: Date) => boolean;
  helpText?: string;
  isClearable?: boolean;
  label: string | ReactNode;
  name: string;
  onBlur?: () => void;
  onChange: (value: string | null) => void;
  placement?: Placement;
  preventOpenOnFocus?: boolean;
  minDate?: Date;
  value: string | null | undefined;
  withPortal?: boolean;
}

function Datepicker({
  autoFocus,
  disabled,
  error,
  filterDate,
  helpText,
  isClearable,
  label,
  name,
  onBlur,
  onChange,
  placement,
  minDate,
  preventOpenOnFocus,
  value,
  withPortal
}: DatepickerProps) {
  const handleChange = (date: Date | null) => {
    onChange(date ? toIsoString(date).split('T')[0] : null);
  };

  return (
    <div className="flex flex-col gap-1">
      <DatetimePicker
        autoFocus={autoFocus}
        dateFormat="M/d/yyyy"
        disabled={disabled}
        error={error}
        filterDate={filterDate}
        helpText={helpText}
        isClearable={isClearable}
        label={label}
        name={name}
        onBlur={onBlur}
        onChange={handleChange}
        placeholder="--/--/----"
        placement={placement}
        minDate={minDate}
        preventOpenOnFocus={preventOpenOnFocus}
        showTimeSelect={false}
        value={value}
        withPortal={withPortal}
      />
      <span className="text-xs text-uniform-gray-500 dark:text-uniform-gray-400">
        {value
          ? new Date(value + 'T00:00:00').toLocaleDateString('en-US', {
              month: 'long',
              day: 'numeric',
              year: 'numeric'
            })
          : ''}
      </span>
    </div>
  );
}

export { Datepicker };
